/** @format */

import {
	GetMembersDistributionDistributionControllerResponse,
	MemberDistributionResponse,
} from "_clients/BFFClient.generated"

const fakeMember: MemberDistributionResponse = {
	allocatedBoosts: 0,
	consumedBoosts: 0,
	name: "n",
	city: "c",
	externalId: "id",
	isEnabled: false,
	rcuID: "rc",
	zipCode: "0",
}
const fakeMembers = [...Array(10)].map((val, idx) => fakeMember)
export const FakeData: GetMembersDistributionDistributionControllerResponse = {
	members: fakeMembers,
	total: 10,
}
